/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Failing_HintInputs */



/**
* | output |
* | --- |
* | "Restore the TXT record to publish the domain again, or remove the domain below." |
*
* @param {Canvas_Domain_Failing_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_failing_hint = /** @type {((inputs?: Canvas_Domain_Failing_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Failing_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellen Sie den TXT-Eintrag wieder her, um die Domain erneut zu veröffentlichen, oder entfernen Sie die Domain unten.")
	return /** @type {LocalizedString} */ ("Restore the TXT record to publish the domain again, or remove the domain below.")
});